<template>
  <div class="GroupMemberList">
    <van-nav-bar title="群成员" fixed @click-left="onClickLeft">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <div v-for="(item,index) in GroupMember[0].group_user" :key="index+''" class="addf" >
        <van-image
          class="err-image-header"
          width="40px"
          height="40px"
          style="margin-top:12px;margin-left:10px;"
          :src="attach_url+item.u_headportrait"
        />
        <van-cell>
          <template slot="title">
            <span>{{item.pivot.ug_group_nick? item.pivot.ug_group_nick:item.f_name.f_name?item.f_name.f_name:item.u_nickname?item.u_nickname:item.u_login_id}}</span>
            <van-icon size="15" name="static/icon/man.png" v-if="item.u_sex === 1" />
            <van-icon size="15" name="static/icon/woman.png" v-else-if="item.u_sex === 0" />
          </template>
          <template slot="label">
            <van-icon size="15" name="static/icon/biaoqian.png" />
            <span>{{item.u_signature}}</span>
          </template>
        </van-cell>
      </div>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  name: "GroupMemberList",
  data() {
    return {
      ug_id: "",
      GroupMember: [],
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre
    };
  },
  created() {
		this.getStateConfigs();
    var params = this.$route.query;
    this.ug_id = params.ug_id;
    this.loadData();
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    loadData() {
      var params = {
        ug_id: this.ug_id,
        token: this.token,
        u_id: this.u_id
      };
      var url =
        this.Conf.serverUrl +
        "Groups/getGroupUserInfoById" +
        "?num=" +
        Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          if (response.data.code == 200) {
            this.GroupMember = response.data.result;
          }
        })
        .catch(error => {});
    },
    //返回
    onClickLeft() {
      this.$router.push({
        name: "GroupChatSet",
        query: {
          ug_id: this.ug_id
        }
      });
    }
    // onClickHead(u_id) {
    // }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/Group/GroupMemberList.vue